import styled from 'styled-components';

export const FileInfo = styled.div`
  max-width: 192px;
  display: flex;
  flex-direction: column;
  white-space: nowrap;

  strong {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }

  span {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 4px;
  border-radius: 50%;
  background: transparent;
  border: none;
  outline: none;

  svg {
    color: #004e9a;
    transition: color 0.2s;
  }

  &:hover {
    svg {
      color: #00366b;
    }
  }
`;
